import { GlobalNewsItem, GlobalNewsResponse } from "@/src/models/news.model";
import { NEWS_GLOBAL_QUERY_KEYS } from "@/src/query-keys/news.keys";
import { formatDate, stripHtml } from "@/src/utils/rss.utils";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
export const useGlobalNewsQuery = (
  options?: Omit<
    UseQueryOptions<GlobalNewsResponse, Error>,
    "queryKey" | "queryFn"
  >,
) => {
  return useQuery<GlobalNewsResponse, Error>({
    queryKey: NEWS_GLOBAL_QUERY_KEYS.globalNews,
    queryFn: async () => {
      const rssUrl = process.env.EXPO_PUBLIC_SELISE_NEWS_URL;
      const proxyUrl = process.env.EXPO_PUBLIC_RSS_PROXY_URL;

      if (!rssUrl) throw new Error("Missing EXPO_PUBLIC_SELISE_NEWS_URL");
      if (!proxyUrl) throw new Error("Missing EXPO_PUBLIC_RSS_PROXY_URL");

      const response = await fetch(
        `${proxyUrl}?url=${encodeURIComponent(rssUrl)}`,
      );

      if (!response.ok) {
        throw new Error(`Proxy error: ${response.status}`);
      }

      const contents = await response.text();

      const parser = new DOMParser();
      const xml = parser.parseFromString(contents, "text/xml");

      const parseError = xml.querySelector("parsererror");
      if (parseError) throw new Error("Failed to parse RSS XML");

      const items = Array.from(xml.querySelectorAll("item")).slice(0, 10);
      if (!items.length) return { news: [] };

      const news: GlobalNewsItem[] = items.map((item) => ({
        title: stripHtml(item.querySelector("title")?.textContent ?? ""),
        link: item.querySelector("link")?.textContent ?? "",
        date: formatDate(item.querySelector("pubDate")?.textContent ?? ""),
        description: stripHtml(
          item.querySelector("description")?.textContent ?? "",
        ),
        category: Array.from(item.querySelectorAll("category")).map(
          (c) => c.textContent ?? "",
        ),
      }));

      return { news };
    },
  });
};
